import { post } from "@src/appV2/api";
import { SHIFT_INVITES_DETAILS_URL } from "@src/appV2/ShiftInvites/constants";
import { useMutation } from "@tanstack/react-query";

import {
  checkShiftInviteDetailsResponseSchema,
  type ShiftInviteRequestParams,
  shiftInviteRequestSchema,
} from "../type";

export function useCheckShiftInviteDetail() {
  return useMutation({
    mutationFn: async (invite: ShiftInviteRequestParams) => {
      const { shiftInviteRequest } = invite;
      return await post({
        url: SHIFT_INVITES_DETAILS_URL,
        data: {
          data: {
            type: "shiftInvite",
            attributes: shiftInviteRequest,
          },
        },
        requestSchema: shiftInviteRequestSchema,
        responseSchema: checkShiftInviteDetailsResponseSchema,
      });
    },
  });
}
